import API from 'services/API/index';

export default function getBannerList() {
  return API.request({
    method: 'GET',
    url: '/banner/system',
    mapper: function (data) {
      return (data || []).map((banner) => ({ ...banner, isClosable: banner.closable }));
    },
  });
}
